module.exports = __webpack_public_path__ + "static/media/Check-Mark-Isolated-Icon.72b2bfbd.png";